// libs
import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
// constants
import { ROUTERS } from "../constants/routers";
// components
import App from "../App";
import LoadingPage from "../components/LoadingPage";
// pages
import KeycloakLoginPage from "../pages/KeycloakLoginPage";
// utils
import { PrivateRoute } from "../utils/appRoutes";

const { HOME, LOGIN } = ROUTERS;

export const AppRouter = () => {
  const { initialized } = useKeycloak();

  if (!initialized) {
    return <LoadingPage />;
  }

  return (
    <BrowserRouter>
      <PrivateRoute path={HOME} component={App} />
      <Route path={LOGIN} exact component={KeycloakLoginPage} />
    </BrowserRouter>
  );
};
